module.exports = __webpack_public_path__ + "static/media/SourceHanSerifTC-SemiBold.849ea43a.woff2";